"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectEpic = exports.initializeEpics = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _reduxObservable = require("redux-observable");

var _js = require("@agile-actors/actions/dist/js");

var _epicMiddleware = require("./epicMiddleware");

var IS_REMOVABLE = Symbol('IS_REMOVABLE');

var epic$ = function epic$() {
  return (0, _rxjs.pipe)((0, _operators.ignoreElements)());
};

var epicsAdded = [];

var rootEpic = function rootEpic(action$) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return epic$.pipe((0, _operators.mergeMap)(function (epic) {
    return epic[IS_REMOVABLE] ? action$.pipe((0, _reduxObservable.ofType)(_js.startRouteEpics.type, _js.stopRouteEpics.type), (0, _operators.filter)(function (_ref) {
      var payload = _ref.payload;
      return payload === epic;
    }), (0, _operators.switchMap)(function (_ref2) {
      var type = _ref2.type;
      return type === _js.startRouteEpics.type ? epic.apply(void 0, [action$].concat(rest)) : _rxjs.NEVER;
    })) : epic.apply(void 0, [action$].concat(rest));
  }));
};

var addEpic = function addEpic(store, epic) {
  if (!epicsAdded.includes(epic)) {
    epic$.next(epic);
    epicsAdded.push(epic);
  }

  store.dispatch((0, _js.startRouteEpics)(epic));
};

var removeEpic = function removeEpic(store, epic) {
  store.dispatch((0, _js.stopRouteEpics)(epic));
};

var injectEpic = function injectEpic(store, epic) {
  // if(typeof window === 'undefined') {
  //   return
  // }
  epic[IS_REMOVABLE] = true;
  addEpic(store, epic);
  return function () {
    return removeEpic(store, epic);
  };
};

exports.injectEpic = injectEpic;

var initializeEpics = function initializeEpics(store) {
  var epic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return (0, _rxjs.pipe)((0, _operators.ignoreElements)());
  }; // if(epicsAdded.length || typeof window === 'undefined') {

  if (epicsAdded.length) {
    return;
  }

  epic[IS_REMOVABLE] = false;
  epic$ = new _rxjs.BehaviorSubject(epic);
  epicsAdded.push(epic);
  (0, _epicMiddleware.getEpicMiddlewareFromStore)(store).run(rootEpic);
  store.dispatch((0, _js.startEpics)());
};

exports.initializeEpics = initializeEpics;